import { IntlProvider } from 'react-intl';
import { styled } from '@linaria/react';
import { CompactHeader } from '@vio/atlas/CompactHeader';
import { Pill } from '@vio/atlas/Pill';
import { RawSkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { SearchSummaryButton } from '@vio/shared/src/search/SearchSummaryButton';
import TrackPerformanceTiming from '@vio/shared/src/utils/PerformanceMonitor/TrackPerformanceTiming';
import { BrandLogo } from '@vio/shared/src/whiteLabel/BrandLogo/BrandLogo';
import { usePageProps } from 'context/unsafePageProps';
import { isSkeletonsExperimentEnabled } from 'utils/experiments';
import { Entity, Page, PerformanceMetric } from '@daedalus/core/src/analytics/types/Events';
import { checkIsBrandHolidayPirates, checkIsBrandVio } from '@daedalus/core/src/brand/utils';
import { SEARCH_ROUTE } from '../constants';
import { HotelCardMobileLoading } from './HotelCardMobile/HotelCardMobileLoading';
import { MobileHeaderMenu } from './MobileHeader/MobileHeaderMenu';
import { SearchNewTopBarComponent, SearchTopBarLogoWrapper } from './SearchNewTopBar';
import { TotalPriceToggleMobile } from './TotalPriceToggle/Mobile/TotalPriceToggleMobile';
const LOADERS_COUNT = 3;
const noop = () => {};
const LayoutWrapper = /*#__PURE__*/styled('div')({
  name: "LayoutWrapper",
  class: "l1pnr5ji",
  propsAsIs: false
});
const QuickFilters = /*#__PURE__*/styled('div')({
  name: "QuickFilters",
  class: "q12aubes",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => Pill;
const QuickFiltersPill = /*#__PURE__*/styled(_exp2())({
  name: "QuickFiltersPill",
  class: "qn2q4pb",
  propsAsIs: true
});
const SearchLayoutContainer = /*#__PURE__*/styled('div')({
  name: "SearchLayoutContainer",
  class: "slpaa8w",
  propsAsIs: false
});

// From SearchSummaryButtonWithStore
const SearchSummaryWrapper = /*#__PURE__*/styled('div')({
  name: "SearchSummaryWrapper",
  class: "svi8xkz",
  propsAsIs: false
});

/**
 * Allows us to use components that expect an IntlProvider - many presentational components do
 */
const EmptyIntlProvider = ({
  children
}) => <IntlProvider locale="en" messages={{}} textComponent="span">
    {children}
  </IntlProvider>;
const Layout = ({
  children
}) => {
  const {
    brand,
    experiments
  } = usePageProps();
  const isNewTopBarExperimentEnabled = experiments?.['1c5ad789-mobile-top-bar'] === 'b';

  // TODO: copied from getBrandProperties selector
  const brandLevelIsBasic = brand?.level === 'basic';
  const brandHasFilters = !brandLevelIsBasic;
  const brandHasCustomHeader = checkIsBrandHolidayPirates(brand);
  const brandIsVio = checkIsBrandVio(brand);
  if (isNewTopBarExperimentEnabled) {
    return <LayoutWrapper>
        <SearchNewTopBarComponent brandIsVio={checkIsBrandVio(brand)} hasShadow hasCustomHeader={brandHasCustomHeader} isMapOpen={false} overlayState={[]} brandLogo={<SearchTopBarLogoWrapper brand={brand} logoUrl={'/'}>
              <BrandLogo brand={brand} height={20} withWhiteText={brandIsVio} />
            </SearchTopBarLogoWrapper>} centerContent={<SearchSummaryWrapper>
              <SearchSummaryButton destination={<RawSkeletonLoader width={100} />} isNewSearchSummary checkIn={null} checkOut={null} numberOfGuests={2} numberOfRooms={1} onClick={noop} />
            </SearchSummaryWrapper>} endContent={<MobileHeaderMenu shouldShowUserAvatar={false} />} bottomContent={brandHasFilters && <QuickFilters>
                <QuickFiltersPill />
              </QuickFilters>} />
        {children}
      </LayoutWrapper>;
  }
  return <LayoutWrapper>
      <CompactHeader hasDivider disableLogoClick showStartLogo brand={brand} BrandLogoComponent={BrandLogo} centerContent={<SearchSummaryWrapper>
            <SearchSummaryButton destination={<RawSkeletonLoader width={100} />} checkIn={null} checkOut={null} numberOfGuests={2} numberOfRooms={1} onClick={noop} />
          </SearchSummaryWrapper>} endContent={<MobileHeaderMenu shouldShowUserAvatar={false} />} bottomContent={brandHasFilters && <QuickFilters>
              <QuickFiltersPill />
            </QuickFilters>} />
      {children}
    </LayoutWrapper>;
};

// Copied from SearchResultsList
const Loaders: React.FC = () => {
  const loadingList: number[] = new Array(LOADERS_COUNT).fill(1);
  return <>
      {loadingList.map((_, i) => <HotelCardMobileLoading key={`HotelCardLoader_${i}`} simpleLoaders />)}
    </>;
};
export const ViewSkeletons = () => {
  const pageProps = usePageProps();
  const isSearchPage = pageProps?.url?.startsWith(SEARCH_ROUTE);
  const showSkeletons = isSkeletonsExperimentEnabled(pageProps);
  if (!isSearchPage) return null;
  if (!showSkeletons) return null;
  return <EmptyIntlProvider>
      <Layout>
        <SearchLayoutContainer>
          <TrackPerformanceTiming entity={Entity.SimpleSkeleton} name={PerformanceMetric.FRP} page={Page.Search} />
          <TotalPriceToggleMobile toggleMessage={<RawSkeletonLoader width={120} />} totalPriceMessage={<RawSkeletonLoader width={200} />} checked={false} onChange={noop} />
          <Loaders />
        </SearchLayoutContainer>
      </Layout>
    </EmptyIntlProvider>;
};

require("./ViewSkeletons.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ViewSkeletons.tsx");